import { render } from "./ReferrelFrom.vue?vue&type=template&id=6dff7d54&scoped=true"
import script from "./ReferrelFrom.vue?vue&type=script&lang=js"
export * from "./ReferrelFrom.vue?vue&type=script&lang=js"

import "./ReferrelFrom.vue?vue&type=style&index=0&id=6dff7d54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dff7d54"]])

export default __exports__